import React, { HTMLAttributes } from 'react';

interface IProperties
  extends Omit<HTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: string;
  iconClassName?: HTMLAttributes<HTMLSpanElement>['className'];
}

const IconButton = (properties: IProperties) => {
  const { icon, className, iconClassName, ...remainingProperties } = properties;
  return (
    <button
      {...remainingProperties}
      className={`rounded-full aspect-square flex justify-center items-center p-1 ${className}`}
    >
      <span className={`material-icons leading-none ${iconClassName}`}>
        {icon}
      </span>
    </button>
  );
};

export default IconButton;
